<template>
  <div>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="2">
          <v-menu transition="scale-transition" offset-y v-model="dateMenu">
            <template v-slot:activator="{ on }">
              <v-text-field label="Month" hide-details dense readonly v-on="on" v-model="monthAsDate" outlined append-icon="mdi-menu-down" @click:append="dateMenu=true"/>
            </template>
            <v-date-picker v-model="month" type="month" no-title @change="refresh"/>
          </v-menu>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Ontario product distribution', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 180px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import {format,add} from 'date-fns'
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsOntarioProductDistribution',
  mixins: [printHtml],
  data() {
    return {
      dateMenu: false,
      month: '',
      ontarioSpiritsReport: null,
    }
  },
  computed: {
    monthAsDate() {
      return this.$formatDate(this.month+'-01', 'MMMM, yyyy');
    },
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'Ontario product distribution')
    this.month = format(add(new Date(), {months:-1}), 'yyyy-MM');
    this.refresh();
  },

  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsOntarioProductDistribution($date:Date!) {
                                             ontarioSpiritsReport(date:$date) {
                                               scheduleA {
                                                 spirits,spiritsCoolers
                                               },
                                               details {
                                                taxableSale {date,customer,product,bottles,strength,volume,amount},
                                                taxableNotSale {date,customer,product,bottles,strength,volume,amount},
                                                licensee {date,customer,product,bottles,strength,volume,amount},
                                                dutyFree {date,customer,product,bottles,strength,volume,amount},
                                                lcbo {date,customer,product,bottles,strength,volume,amount},
                                                export {date,customer,product,bottles,strength,volume,amount},
                                                nonTaxable {date,customer,product,bottles,strength,volume,amount}
                                                }
                                              }
                                            }`,
                                            {date:this.month+'-01'});
      if (!results.error) {
        this.ontarioSpiritsReport = results.data.ontarioSpiritsReport;
      }
      this.loading = false;
    },

    report() {
      if (!this.ontarioSpiritsReport)
        return '';
      const lines = [`<style>
                @page {size:landscape}
                .report-product-distribution {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                .report-product-distribution th {height:36px;padding:0 16px;vertical-align:middle}
                .report-product-distribution td {height:36px;padding:0 16px;vertical-align:middle}
                .report-product-distribution .title {font-size:18px;text-transform:uppercase}
                .report-product-distribution .sup-title {font-weight:normal;font-size:22px}
                .report-product-distribution .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                .report-product-distribution .header th {border-bottom:1px solid #000;margin-bottom:20px}
                .report-product-distribution .text-left {text-align:left}
                .report-product-distribution .text-right {text-align:right}
                .report-product-distribution .font-weight-bold {font-weight:bold}
              </style>
              <table class="report-product-distribution">
                <thead>
                  <tr>
                    <th colspan="7" class="sup-title">${this.$store.getters.company.name}</th>
                  </tr>
                  <tr>
                    <th colspan="7" class="title">Ontario product distribution</th>
                  </tr>
                  <tr>
                    <th colspan="7" class="sub-title">${this.monthAsDate}</th>
                  </tr>
                  <tr class="header">
                    <th width="5%" class="text-left"></th>
                    <th width="15%" class="text-left">Date</th>
                    <th width="25%" class="text-left">Customer</th>
                    <th width="25%" class="text-left">Product</th>
                    <th width="10%" class="text-right">Bottles</th>
                    <th width="10%" class="text-right">Spirits</th>
                    <th width="10%" class="text-right">Spirits Coolers</th>
                  </tr>
                </thead>
                <tbody>`];

      lines.push(`<tr><td colspan="7" class="font-weight-bold">Taxable distribution ($)</td></tr>`);
      let bottlesTotal = 0;
      bottlesTotal += this.writeDollarLines(lines, this.ontarioSpiritsReport.details.taxableSale, 'Taxable Distribution (by sale)', 0);
      bottlesTotal += this.writeDollarLines(lines, this.ontarioSpiritsReport.details.taxableNotSale, 'Taxable Distribution (other than by sale)', 1);
      lines.push(`<tr class="font-weight-bold"><td>3</td><td colspan="3">Total Taxable Distribution</td><td class="text-right">${bottlesTotal}</td><td class="text-right">${this.aDollars(true, 2)}</td><td class="text-right">${this.aDollars(false, 2)}</td></tr>`);

      lines.push(`<tr><td colspan="7" class="font-weight-bold">Non-Taxable distribution ($)</td></tr>`);
      bottlesTotal = 0;
      bottlesTotal += this.writeDollarLines(lines, this.ontarioSpiritsReport.details.licensee, 'Direct Delivery Sales to Licensees', 3);
      bottlesTotal += this.writeDollarLines(lines, this.ontarioSpiritsReport.details.dutyFree, 'Duty Free Sales in Ontario', 4);
      bottlesTotal += this.writeDollarLines(lines, this.ontarioSpiritsReport.details.lcbo, 'Other LCBO Sales', 5);
      bottlesTotal += this.writeDollarLines(lines, this.ontarioSpiritsReport.details.export, 'Exports', 6);
      bottlesTotal += this.writeDollarLines(lines, this.ontarioSpiritsReport.details.nonTaxable, 'Non-Taxable Distribution (other than by sale)', 7);
      lines.push(`<tr class="font-weight-bold"><td>9</td><td colspan="3">Total Non-Taxable Distribution</td><td class="text-right">${bottlesTotal}</td><td class="text-right">${this.aDollars(true, 8)}</td><td class="text-right">${this.aDollars(false, 8)}</td></tr>`);

      lines.push(`<tr><td colspan="7" class="font-weight-bold">Taxable distribution (litres)</td></tr>`);
      bottlesTotal = 0;
      bottlesTotal += this.writeLitresLines(lines, this.ontarioSpiritsReport.details.taxableSale, 'Taxable Distribution (by sale)', 9);
      bottlesTotal += this.writeLitresLines(lines, this.ontarioSpiritsReport.details.taxableNotSale, 'Taxable Distribution (other than by sale)', 10);
      lines.push(`<tr class="font-weight-bold"><td>12</td><td colspan="3">Total Taxable Distribution</td><td class="text-right">${bottlesTotal}</td><td class="text-right">${this.aLitres(true, 11)}</td><td class="text-right">${this.aLitres(false, 11)}</td></tr>`);

      lines.push(`<tr><td colspan="7" class="font-weight-bold">Non-Taxable distribution (litres)</td></tr>`);
      bottlesTotal = 0;
      bottlesTotal += this.writeLitresLines(lines, this.ontarioSpiritsReport.details.licensee, 'Direct Delivery Sales to Licensees', 12);
      bottlesTotal += this.writeLitresLines(lines, this.ontarioSpiritsReport.details.dutyFree, 'Duty Free Sales in Ontario', 13);
      bottlesTotal += this.writeLitresLines(lines, this.ontarioSpiritsReport.details.lcbo, 'Other LCBO Sales', 14);
      bottlesTotal += this.writeLitresLines(lines, this.ontarioSpiritsReport.details.export, 'Exports', 15);
      bottlesTotal += this.writeLitresLines(lines, this.ontarioSpiritsReport.details.nonTaxable, 'Non-Taxable Distribution (other than by sale)', 16);
      lines.push(`<tr class="font-weight-bold"><td>18</td><td colspan="3">Total Non-Taxable Distribution</td><td class="text-right">${bottlesTotal}</td><td class="text-right">${this.aLitres(true, 17)}</td><td class="text-right">${this.aLitres(false, 17)}</td></tr>`);

      lines.push(`</tbody></table>`);
      return lines.join('');
    },
    writeDollarLines(lines, section, title, index) {
      lines.push(`<tr><td>${index+1}</td><td colspan="6">${title}</td></tr>`);
      let bottlesTotal = 0;
      for (const line of section) {
        bottlesTotal += line.bottles;
        lines.push(`<tr><td/><td>${this.date(line.date)}</td><td>${line.customer}</td><td>${line.product}</td><td class="text-right">${line.bottles}</td><td class="text-right">${this.dollars(line.strength>14.8?line.amount:0)}</td><td class="text-right">${this.dollars(line.strength<=14.8?line.amount:0)}</td></tr>`);
      }
      lines.push(`<tr class="font-weight-bold"><td colspan="4"/><td class="text-right">${bottlesTotal}</td><td class="text-right">${this.aDollars(true, index)}</td><td class="text-right">${this.aDollars(false, index)}</td></tr>`);
      return bottlesTotal;
    },
    writeLitresLines(lines, section, title, index) {
      lines.push(`<tr><td>${index+1}</td><td colspan="6">${title}</td></tr>`);
      let bottlesTotal = 0;
      for (const line of section) {
        bottlesTotal += line.bottles;
        lines.push(`<tr><td/><td>${this.date(line.date)}</td><td>${line.customer}</td><td>${line.product}</td><td class="text-right">${line.bottles}</td><td class="text-right">${this.litres(line.strength>14.8?line.volume:0)}</td><td class="text-right">${this.litres(line.strength<=14.8?line.volume:0)}</td></tr>`);
      }
      lines.push(`<tr class="font-weight-bold"><td colspan="4"/><td class="text-right">${bottlesTotal}</td><td class="text-right">${this.aLitres(true, index)}</td><td class="text-right">${this.aLitres(false, index)}</td></tr>`);
      return bottlesTotal;
    },
    aDollars(spirits, line) {
      const value = this.ontarioSpiritsReport.scheduleA[spirits ? 'spirits' : 'spiritsCoolers'][line];
      return this.$currency(value);
    },
    dollars(value) {
      return this.$currency(value);
    },
    aLitres(spirits, line) {
      const value = this.ontarioSpiritsReport.scheduleA[spirits ? 'spirits' : 'spiritsCoolers'][line];
      return this.$number(value, 3);
    },
    litres(value) {
      return this.$number(value, 3);
    },
    date(date) {
      return this.$formatDate(date);
    },

    exportCSV() {
      const lines = [ `"${this.$store.getters.company.name}",,,,,,`,
                      `"Ontario product distribution",,,,,,`,
                      `"${this.monthAsDate}",,,,,,`,
                      `,"Date","Customer","Product","Bottles","Spirits","Spirits Coolers"`
                    ];
      lines.push(`"Taxable distribution ($)",,,,,,`);
      let bottlesTotal = 0;
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.taxableSale, 'Taxable Distribution (by sale)', 0, true);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.taxableNotSale, 'Taxable Distribution (other than by sale)', 1, true);
      lines.push(`"3",,"Total Taxable Distribution",,"${bottlesTotal}","${this.ontarioSpiritsReport.scheduleA['spirits'][2]}","${this.ontarioSpiritsReport.scheduleA['spiritsCoolers'][2]}"`);

      lines.push(`"Non-Taxable distribution ($)",,,,,,`);
      bottlesTotal = 0;
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.licensee, 'Direct Delivery Sales to Licensees', 3, true);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.dutyFree, 'Duty Free Sales in Ontario', 4, true);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.lcbo, 'Other LCBO Sales', 5, true);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.export, 'Exports', 6, true);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.nonTaxable, 'Non-Taxable Distribution (other than by sale)', 7, true);
      lines.push(`"9",,"Total Non-Taxable Distribution",,"${bottlesTotal}","${this.ontarioSpiritsReport.scheduleA['spirits'][8]}","${this.ontarioSpiritsReport.scheduleA['spiritsCoolers'][8]}"`);

      lines.push(`"Taxable distribution (litres)",,,,,,`);
      bottlesTotal = 0;
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.taxableSale, 'Taxable Distribution (by sale)', 9, false);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.taxableNotSale, 'Taxable Distribution (other than by sale)', 10, false);
      lines.push(`"12",,"Total Taxable Distribution",,"${bottlesTotal}","${this.ontarioSpiritsReport.scheduleA['spirits'][11]}","${this.ontarioSpiritsReport.scheduleA['spiritsCoolers'][11]}"`);

      lines.push(`"Non-Taxable distribution (litres)",,,,,,`);
      bottlesTotal = 0;
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.licensee, 'Direct Delivery Sales to Licensees', 12, false);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.dutyFree, 'Duty Free Sales in Ontario', 13, false);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.lcbo, 'Other LCBO Sales', 14, false);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.export, 'Exports', 15, false);
      bottlesTotal += this.csvLines(lines, this.ontarioSpiritsReport.details.nonTaxable, 'Non-Taxable Distribution (other than by sale)', 16, false);
      lines.push(`"18",,"Total Non-Taxable Distribution",,"${bottlesTotal}","${this.ontarioSpiritsReport.scheduleA['spirits'][17]}","${this.ontarioSpiritsReport.scheduleA['spiritsCoolers'][17]}"`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Ontario product distribution.csv');
    },
    csvLines(lines, section, title, index, amount) {
      lines.push(`"${index+1}","${title}",,,,,`);
      let bottlesTotal = 0;
      for (const line of section) {
        bottlesTotal += line.bottles;
        lines.push(`,"${this.date(line.date)}","${line.customer}","${line.product}","${line.bottles}","${line.strength>14.8?(amount?line.amount:line.volume):0}","${line.strength<=14.8?(amount?line.amount:line.volume):0}"`);
      }
      lines.push(`,,,,"${bottlesTotal}","${this.ontarioSpiritsReport.scheduleA['spirits'][index]}","${this.ontarioSpiritsReport.scheduleA['spiritsCoolers'][index]}"`);
      return bottlesTotal;
    }

  }
}
</script>